import { useEffect, useRef, useState } from 'react';
import QRCodeStyling from 'qr-code-styling';

interface SimpleQrViewProps {
	url: string;
	size?: number;
}

/**
 * Bare QR code with the CardSimp styling (rounded dots, extra-rounded corner
 * squares, dot corner dots) rendered on a white rounded card. No headline,
 * no username, no download controls — just the code.
 */
export const SimpleQrView = ({ url, size = 260 }: SimpleQrViewProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const [qr] = useState(
		() =>
			new QRCodeStyling({
				width: size,
				height: size,
				type: 'svg',
				data: url,
				dotsOptions: { color: '#000000', type: 'rounded' },
				backgroundOptions: { color: 'transparent' },
				cornersSquareOptions: { color: '#000000', type: 'extra-rounded' },
				cornersDotOptions: { color: '#000000', type: 'dot' },
			}),
	);

	useEffect(() => {
		if (ref.current) {
			ref.current.innerHTML = '';
			qr.append(ref.current);
		}
	}, [qr]);

	useEffect(() => {
		qr.update({ data: url, width: size, height: size });
	}, [qr, url, size]);

	return (
		<div
			className="mx-auto rounded-xl bg-white flex items-center justify-center"
			style={{ padding: 8, width: size + 16, height: size + 16 }}
		>
			<div ref={ref} style={{ width: size, height: size }} />
		</div>
	);
};
